module.exports = __webpack_public_path__ + "static/media/wai-o-tapu-thermal-pools.c16b7210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/wai-o-tapu-thermal-pools.jpg
// module id = 154
// module chunks = 0